export default "__VITE_ASSET__szatkiIV__"